import styled from 'styled-components';

const StyledContainer = styled.div `
  background-color: ${({ theme }) => theme.colors.backgroundColor};
  display: flex;
  align-items: stretch;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    min-height: calc(100vh - 282.8px);
  }
`;
const StyledRegionContainer = styled.div `
  width: 30%;
  background: ${({ theme }) => theme.colors.navigationRegionBackground};
  padding: 42px 60px;
`;
const StyledListContainer = styled.div `
  max-width: 210px;
  margin-bottom: 52px;
  margin-top: -20px;
`;

export { StyledContainer, StyledListContainer, StyledRegionContainer };
//# sourceMappingURL=DesktopNavigation.styles.mjs.map
